// extracted by mini-css-extract-plugin
module.exports = {"content":"NavbarContent-module--content--vhdFD","menuButton":"NavbarContent-module--menuButton--3MZHM","navigations":"NavbarContent-module--navigations--2_bBq"};